import React, { Suspense, lazy } from 'react';
import './App.css';
import './components/SectionDividers.css'; // Import the new divider styles
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import BackToTopButton from './components/BackToTopButton';

const Home = lazy(() => import('./components/Home'));
const FAQ = lazy(() => import('./components/FAQ'));
const PressKit = lazy(() => import('./components/PressKit'));
const Teams = lazy(() => import('./components/Teams'));
const TeamPage = lazy(() => import('./components/TeamPage'));
const VRExperience = lazy(() => import('./components/VRExperience'));
const Contact = lazy(() => import('./components/Contact'));
const PrivacyPolicy = lazy(() => import('./components/PrivacyPolicy'));

function App() {
  return (
    <Router basename="/">
      <div className="App">
        <Navbar />
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/press-kit" element={<PressKit />} />
            <Route path="/teams" element={<Teams />} />
            <Route path="/teams/:teamName" element={<TeamPage />} />
            <Route path="/vr-experience" element={<VRExperience />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          </Routes>
        </Suspense>
        <Footer />
        <BackToTopButton />
      </div>
    </Router>
  );
}

export default App;
